<template>
  <div class="content-brand" id="home-atalhos" data-search-anchor>
    <div class="title-brand-wrapper">      
      <h1 class="brand-title">{{ brandTitle }}</h1>
    </div>    
    <div class="cards">
      <CardBrand
        class="card-item-position-1"
        :style="{ backgroundImage: `url(${brandImageSrcPosition1})` }"        
        >
        <div class="text-position-1">
          <h2>{{ brandTitlePosition1 }}</h2>
          <p>{{ brandDescriptionPosition1 }}</p>          
        </div>
        <HomeDownloadPdf class="download-pdf-overlay"
        :fileSrc="downloadPdf"
        downloadName="Globo_LivroDaMarca.pdf"       
      />
      </CardBrand>

      <router-link class="no-decor" :to="{ name: 'identidade-visual.logo' }" >
        <CardBrand
        class="card-item-position-2"
        :style="{ backgroundImage: `url(${brandImageSrcPosition2})` }"
        >
        <div class="text-position-2">
          <h2>{{ brandTitlePosition2 }}</h2>
          <p>{{ brandDescriptionPosition2 }}</p>          
        </div>
        </CardBrand>
      </router-link>
      
      <router-link class="no-decor" :to="{ name: 'identidade-visual.color' }" >
        <CardBrand
        class="card-item-position-3"
        :style="{ backgroundImage: `url(${brandImageSrcPosition3})` }"
        >
        <div class="text-position-3">
          <h2>{{ brandTitlePosition3 }}</h2>
          <p>{{ brandDescriptionPosition3 }}</p>          
        </div>
        </CardBrand>
      </router-link>
      
      <router-link class="no-decor" :to="{ name: 'identidade-visual.grafismos' }" >
        <CardBrand
        class="card-item-position-4"
        :style="{ backgroundImage: `url(${brandImageSrcPosition4})` }"
        >
        <div class="text-position-4">
          <h2>{{ brandTitlePosition4 }}</h2>
          <p>{{ brandDescriptionPosition4 }}</p>          
        </div>
        </CardBrand>
      </router-link>
      
      <router-link class="no-decor" :to="{ name: 'plataforma-de-marca.personalidade' }" >
        <CardBrand
        class="card-item-position-5"
        :style="{ backgroundImage: `url(${brandImageSrcPosition5})` }"
        >
        <div class="text-position-5">
          <h2>{{ brandTitlePosition5 }}</h2>
          <p>{{ brandDescriptionPosition5 }}</p>          
        </div>
        </CardBrand>
      </router-link>
      
      <router-link class="no-decor" :to="{ name: 'identidade-visual.ilustracao' }" >
        <CardBrand
        class="card-item-position-6"
        :style="{ backgroundImage: `url(${brandImageSrcPosition6})` }"
        >
        <div class="text-position-6">
          <h2>{{ brandTitlePosition6 }}</h2>
          <p>{{ brandDescriptionPosition6 }}</p>          
        </div>
        </CardBrand>        
      </router-link>
        
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import CardBrand from '../CardBrand.vue'
import HomeDownloadPdf from '../HomeDownloadPdf.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import { getModule } from 'vuex-module-decorators'
import { HomePageStore } from '@/store/home-page/home-store'
import HomePageMixin from '@/mixins/home-page-mixin'

@Component({
  components: {
    CardBrand,
    HomeDownloadPdf
  }
})
export default class BrandSection extends Mixins(HomePageMixin) {
  homePageStore: PageStoreContract = getModule(HomePageStore, this.$store)

  get brandTitle(): string {
    return this.getElementTitle(1, 7)
  }

  get brandTitlePosition1(): string {
    return this.getElementTitle(1, 0)
  }

  get brandDescriptionPosition1(): string {
    return this.getElementText(1, 0)
  }

  get brandImageSrcPosition1(): string {
    return this.getElementMedia(1, 0)
  }

  get brandTitlePosition2(): string {
    return this.getElementTitle(1, 1)
  }

  get brandDescriptionPosition2(): string {
    return this.getElementText(1, 1)
  }

  get brandImageSrcPosition2(): string {
    return this.getElementMedia(1, 1)
  }

  get brandTitlePosition3(): string {
    return this.getElementTitle(1,2)
  }

  get brandDescriptionPosition3(): string {
    return this.getElementText(1, 2)
  }

  get brandImageSrcPosition3(): string {
    return this.getElementMedia(1, 2)
  }

  get brandTitlePosition4(): string {
    return this.getElementTitle(1, 3)
  }

  get brandDescriptionPosition4(): string {
    return this.getElementText(1, 3)
  }

  get brandImageSrcPosition4(): string {
    return this.getElementMedia(1, 3)
  }

  get brandTitlePosition5(): string {
    return this.getElementTitle(1, 4)
  }

  get brandDescriptionPosition5(): string {
    return this.getElementText(1, 4)
  }

  get brandImageSrcPosition5(): string {
    return this.getElementMedia(1, 4)
  }

  get brandTitlePosition6(): string {
    return this.getElementTitle(1, 5)
  }

  get brandDescriptionPosition6(): string {
    return this.getElementText(1, 5)
  }

  get brandImageSrcPosition6(): string {
    return this.getElementMedia(1, 5)
  }

  get downloadPdf(): string {
    return this.getElementMedia(1, 6)
  }

  async getHomePage(): Promise<void> {
    await this.homePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.homePageStore.isLoading) {
      await this.getHomePage()
    }
  }
}
</script>

<style scoped lang="scss">
.content-brand {  
  padding: 1rem 0px 3.18rem 0rem;   
  max-width: 1032px;
  width: 100%;
}

.brand-title {  
  font-size: 30px;
  font-weight: 500;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr)); 
  grid-row-gap: 24px; 
  grid-column-gap: 29px; 
  max-width: 1066px;
  cursor: pointer;  
}


.card-item-position-1{  
  overflow: hidden;  
}

.card-item-position-1,
.card-item-position-2,
.card-item-position-3,
.card-item-position-4,
.card-item-position-5,
.card-item-position-6 {
  box-sizing: border-box;  
  position: relative;
  max-width: 100%; 
  width: 527px;
  height: 300px;
  background: #4f4f4d;
  border-radius: 12px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.card-item-position-1 h2,
.card-item-position-2 h2,
.card-item-position-3 h2,
.card-item-position-4 h2,
.card-item-position-5 h2,
.card-item-position-6 h2 {
  color: #fff;
  margin-bottom: 0;
  font-size: 2.5rem;
  font-weight: 100;
}

.card-item-position-1 p,
.card-item-position-2 p,
.card-item-position-3 p,
.card-item-position-4 p,
.card-item-position-5 p,
.card-item-position-6 p {
  color: #fff;
}

.text-position-1,
.text-position-2,
.text-position-3,
.text-position-4,
.text-position-5,
.text-position-6 {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 2rem;
  z-index: 2
}

.download-pdf-overlay {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 527px; 
  height: 300px;
  border-radius: 12px;  
  background: rgba(0, 0, 0, 0); 
  cursor: pointer; 
  z-index: 1; 
}


@media (min-width: 1726px) {
  .content-brand {
    margin-top: 0rem;
  }  
}

.card-item-position-1::after,
.card-item-position-2::after,
.card-item-position-3::after,
.card-item-position-4::after,
.card-item-position-5::after,
.card-item-position-6::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(179.73deg, rgba(0, 0, 0, 0) 38.89%, rgba(0, 0, 0, 0.8) 99.76%);
  border-radius: 0 0 12px 12px;
  z-index: 1;
  pointer-events: none;
}

</style>
